/**
 *  @class
 *  @function VideoControls
 */

// Global video state management
window.videoState = window.videoState || {
  isMuted: true,
  setGlobalMuted: function(muted) {
    this.isMuted = muted;
    // Apply to all videos
    document.querySelectorAll('video-controls').forEach(control => {
      if (control.applyGlobalState) {
        control.applyGlobalState();
      }
    });
  }
};

if (!customElements.get('video-controls')) {
  class VideoControls extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.video = this.parentElement.querySelector('video');
      this.sound_toggle = this.querySelector('.video-controls--sound');
      this.play_toggle = this.querySelector('.video-controls--play-pause');

      this.setEventListeners();
      this.applyGlobalState();
    }
    setEventListeners() {
      if (this.play_toggle) {
        this.play_toggle.addEventListener('click', this.playPause.bind(this));
      }
      if (this.sound_toggle) {
        this.sound_toggle.addEventListener('click', this.muteUnmute.bind(this));
      }
    }
    playPause(e) {
      if (!this.video || !this.play_toggle) return;
      if (this.video.paused) {
        this.video.play();
        this.play_toggle.classList.remove('paused');
      } else {
        this.video.pause();
        this.play_toggle.classList.add('paused');
      }
      e.stopPropagation();
    }
    muteUnmute(e) {
      if (!this.video || !this.sound_toggle) return;
      
      // Toggle muted state and update global state
      const newMutedState = !this.video.muted;
      window.videoState.setGlobalMuted(newMutedState);
      
      e.stopPropagation();
    }
    
    applyGlobalState() {
      if (!this.video || !this.sound_toggle) return;
      
      // Apply global muted state to this video
      this.video.muted = window.videoState.isMuted;
      
      // Update button appearance
      if (window.videoState.isMuted) {
        this.sound_toggle.classList.add('muted');
      } else {
        this.sound_toggle.classList.remove('muted');
      }
    }
  }
  customElements.define('video-controls', VideoControls);
}
